import { z } from 'zod';
export const groupMemberResponseSchema = z
    .object({
    membership: z
        .object({
        id: z.string().uuid(),
        userId: z.string().uuid(),
        groupId: z.string().uuid(),
        kind: z.enum(['admin', 'member']),
        roleId: z.string().uuid().nullable(),
        scope: z.enum(['all', 'specific']),
        orgIds: z.array(z.string().uuid()),
        createdAt: z.string(),
        updatedAt: z.string(),
        deletedAt: z.string().nullable(),
        lastUsedAt: z.string().nullable(),
    })
        .strict(),
    effective_permissions_preview: z.array(z
        .object({
        organizationId: z.string().uuid(),
        slugs: z.array(z.string()),
    })
        .strict()),
})
    .strict();
//# sourceMappingURL=group-member-response.schema.js.map